export default {
  name: 'EggAd',
  settingKey: '碰蛋广告位',
  setting: {
    图片: {
      type: 'image',
      default: 'https://puui.qpic.cn/vupload/0/1564478651357_y1zwqwvi13b/0'
    },
    链接: ''
  },
  computed: {
    currentSetting: function currentSetting() {
      if (this.$store.state.indexPageModule.serverSetting && this.$store.state.indexPageModule.serverSetting['碰蛋广告位']) {
        return this.$store.state.indexPageModule.serverSetting['碰蛋广告位'];
      }
      return this.setting;
    }
  }
};